import { radialCommonOption, radialCommonOption2, radialCommonOption3, radialCommonOption4 } from "./WidgetsChartData";

export const socialWidgetsData = [
    {
        image:"1",
        alt:"facebook icon",
        title:"Facebook",
        count:"+22.9%",
        followers:"12,098",
        content:"Followers",
        id:"radial-facebook",
        chart:radialCommonOption
    },
    {
        image:"3",
        alt:"twitter icon",
        title:"Twitter",
        count:"+14.09%",
        followers:"12,564",
        content:"Followers",
        id:"radial-twitter",
        chart:radialCommonOption3
    },
    {
        image:"2",
        alt:"instagram icon",
        title:"Instagram",
        count:"+27.4%",
        followers:"15,080",
        content:"Followers",
        id:"radial-instagram",
        chart:radialCommonOption2
    },
    {
        image:"4",
        alt:"you tube icon",
        title:"Youtube",
        count:"+22.9%",
        followers:"68,954",
        content:"Followers",
        id:"radial-youtube",
        chart:radialCommonOption4
    }
]

export const totalStudentData = [
    {
        student:"42,954",
        title:"Total Students",
        color:"danger",
        icon:"down",
        percentage:"- 17.06%",
        detail:"than last 6 Month",
        image:"student.png",
        class:"student"
    },
    {
        student:"659",
        title:"Total Teachers",
        color:"success",
        icon:"up",
        percentage:"+27.02%",
        detail:"than last 4 Month",
        image:"teacher.png",
        class:"student-2"
    },
    {
        student:"984",
        title:"Events",
        color:"success",
        icon:"up",
        percentage:"+ 12.01%",
        detail:"than last 8 Month",
        image:"calendar.png",
        class:"student-3"
    },
    {
        student:"1,984",
        title:"Invoice Status",
        color:"danger",
        icon:"down",
        percentage:"- 15.02%",
        detail:"than last 5 Month",
        image:"invoice.png",
        class:"student-4"
    },
]

